export const calculate_as_low_as_payment = (total) => {
    let calculated_total = (total * 1.11) / 12
    if (calculated_total < 6.0) {
        calculated_total = calculated_total.toFixed(2)
    } else {
        calculated_total = calculated_total.toFixed(0)
    }
    return calculated_total
}
